import { render, staticRenderFns } from "./addOrderForm.vue?vue&type=template&id=5ae6b76d&scoped=true"
import script from "./addOrderForm.vue?vue&type=script&lang=js"
export * from "./addOrderForm.vue?vue&type=script&lang=js"
import style0 from "./addOrderForm.vue?vue&type=style&index=0&id=5ae6b76d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae6b76d",
  null
  
)

export default component.exports